import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  Paper,
  TextField,
  Typography,
  Divider,
  InputAdornment,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
} from "@material-ui/core";
import { Info } from "@material-ui/icons";

import { green } from "@material-ui/core/colors";
import React, { useState, useEffect } from "react";
import axios from "axios";

import {
  Edit,
  Visibility,
  Search as SearchIcon,
  ArrowDropDown,
  Refresh,
  ChevronLeft,
  ChevronRight,
} from "@material-ui/icons";

import { PDFViewer } from "../../sasl/batch/updateBatch/StructuredInformation/PDFViewer";
import { appUrl } from "../../../../../../utils/config";

const initialValuesFromDb = {
  finished_product_name: {
    value: "FG Baraclude",
    confidence: "99.85192108154297"
  },
  customer_finished_product_item_code: {
    value: "1223158",
    confidence: "99.970703125"
  },
  datalogger_item_code: {
    value: "N/A",
    confidence: "99.990234375"
  },
  "transport_condition_(Ambient Temperature)+15/+25": {
    value: "Yes",
    confidence: "99.990234375"
  },
  "transport_condition_(Cold Store)+2/+8": {
    value: "N/A",
    confidence: "99.990234375"
  },
  truck_temperature_prior_to_sealing: {
    value: "20.6 C°",
    confidence: "93.4814453125"
  },
  date_truck_closed_sealed: {
    value: "05 Jun 2024",
    confidence: "92.4118423461914"
  },
  document_type: "FinishedProductDispatchCheckList",
  folder_name: "PCI",
  site_name: "Dublin",
  filename: "PCI-Dublin-FinishedProductDispatchCheckList-4500023887-BatchTest2A.pdf",
  s3_location: "s3://bms-processed-files/PCI/Dublin/4500023887-BatchTest2A/PCI-Dublin-FinishedProductDispatchCheckList-4500023887-BatchTest2A.pdf"
};

// styling
const useStyles = makeStyles((theme) => ({
  formLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minWidth: "150px",
    paddingRight: theme.spacing(2),
    textAlign: "right",
  },
  fixedLabel: {
    width: 180,
    textAlign: "left",
    paddingRight: theme.spacing(2),
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
  sectionTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  testTable: {
    '& .MuiTableCell-head': {
      backgroundColor: '#f5f5f5',
      fontWeight: 'bold',
    },
  },
}));

const FinishedProductCheckList = (props) => {
  const { initialData, onClose, schrockenCustomFileID, digitizedData } = props;
  const [isEditable, setIsEditable] = useState(false);
  const [formValues, setFormValues] = useState(initialData || {});
  const [originalValues, setOriginalValues] = useState(initialData || {});
  const [editedValues, setEditedValues] = useState(initialData || {});
  const [showingOriginal, setShowingOriginal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [modalData, setModalData] = useState({
    field: "",
    before: "",
    after: "",
    updatedBy: "user123",
    timestamp: new Date().toLocaleString(),
  });

  const classes = useStyles();

  useEffect(() => {
    const dataToUse = initialData || {};
    setFormValues(dataToUse);
    setOriginalValues(dataToUse);
    setEditedValues(dataToUse);
  }, [initialData]);

  // Validation functions based on data types
  const validateField = (fieldKey, value) => {
    const validations = {
      finished_product_name: {
        type: "Text",
        validate: (val) => {
          if (!val || val.trim() === '') return "Sponsor Description is required";
          if (val.length < 3) return "Description should be more detailed";
          return null;
        }
      },
      customer_finished_product_item_code: {
        type: "Numeric",
        validate: (val) => {
          if (!val || val.trim() === '') return "Sponsor SKU is required";
          if (!/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      datalogger_item_code: {
        type: "Text",
        validate: (val) => {
          if (!val || val.trim() === '') return "TempTale Serial Number is required";
          return null;
        }
      },
      truck_temperature_prior_to_sealing: {
        type: "Temperature",
        validate: (val) => {
          if (!val || val.trim() === '') return "Truck Temperature Prior to Sealing is required";
          if (!/^\d+(\.\d+)?\s*°?C$/i.test(val)) return "Must be temperature format (e.g., 20.6°C)";
          return null;
        }
      },
      "transport_condition_(Ambient Temperature)+15/+25": {
        type: "Select",
        validate: (val) => {
          if (!val || val.trim() === '') return "Transport Condition (Ambient Temperature) +15/+25 is required";
          return null;
        }
      },
      "transport_condition_(Cold Store)+2/+8": {
        type: "Select",
        validate: (val) => {
          if (!val || val.trim() === '') return "Transport Condition (Cold Store) -2/+8 is required";
          return null;
        }
      },
      date_truck_closed_sealed: {
        type: "Date DD MMM YYYY",
        validate: (val) => {
          if (!val || val.trim() === '') return "CMO Readiness Date is required";
          if (!/^\d{2}\s[A-Za-z]{3}\s\d{4}$/.test(val)) return "Must be in DD MMM YYYY format";
          return null;
        }
      }
    };

    const fieldValidation = validations[fieldKey];
    if (fieldValidation) {
      return fieldValidation.validate(value);
    }
    return null;
  };

  // const validateAllFields = () => {
  //   const errors = {};
  //   Object.keys(formValues).forEach(fieldKey => {
  //     if (typeof formValues[fieldKey] === 'string') { // Only validate actual form fields, not metadata
  //       const error = validateField(fieldKey, formValues[fieldKey]);
  //       if (error) {
  //         errors[fieldKey] = error;
  //       }
  //     }
  //   });
  //   setValidationErrors(errors);
  //   console.log(errors, 'errors')
  //   return Object.keys(errors).length === 0;
  // };
  const validateAllFields = () => {
    const errors = {};
    Object.keys(formValues).forEach(fieldKey => {
      if (typeof formValues[fieldKey] === 'object' && formValues[fieldKey].value !== undefined) { // Only validate actual form fields, not metadata
        const error = validateField(fieldKey, getValueForField(fieldKey));
        if (error) {
          errors[fieldKey] = error;
        }
      }
    });
    setValidationErrors(errors);
    //console.log(errors, 'errors');
    return Object.keys(errors).length === 0;
  };

  const getConfidenceForField = (fieldKey) => {
    // Since this data structure doesn't have confidence values, return defaults based on image
    // const defaultConfidences = {
    //   finished_product_name: 94,
    //   customer_finished_product_item_code: 94,
    //   datalogger_item_code: 94,
    //   truck_temperature_prior_to_sealing: 94,
    //   "transport_condition_(Ambient Temperature)+15/+25": 92,
    //   "transport_condition_(Cold Store)+2/+8": 92,
    //   date_truck_closed_sealed: 92
    // };
    //return defaultConfidences[fieldKey] || 90;
    const fieldData = formValues[fieldKey];
  if (fieldData && fieldData.confidence) {
    return parseFloat(fieldData.confidence);
  }
  return 90; // Default fallback
  };

  const getValueForField = (fieldKey, dataSource = formValues) => {
    const fieldData = dataSource[fieldKey];
    if (fieldData && typeof fieldData === 'object' && fieldData.value !== undefined) {
      return fieldData.value || '';
    }
    return fieldData || '';
  };

  const getLevelColor = (level) => {
    if (level < 80) return "red";
    if (level <= 90) return "orange";
    return "green";
  };

  // const handleInputChange = (fieldKey, value) => {
  //   const newValues = {
  //     ...formValues,
  //     [fieldKey]: value
  //   };
  //   setFormValues(newValues);
  //   if (!showingOriginal) {
  //     setEditedValues(newValues);
  //   }

  //   // Validate the field and update errors
  //   const error = validateField(fieldKey, value);
  //   setValidationErrors(prev => ({
  //     ...prev,
  //     [fieldKey]: error
  //   }));
  // };
  const handleInputChange = (fieldKey, value) => {
    const newValues = {
      ...formValues,
      [fieldKey]: {
        ...formValues[fieldKey],
        value: value
      }
    };
    setFormValues(newValues);
    if (!showingOriginal) {
      setEditedValues(newValues);
    }
  
    // Validate the field and update errors
    const error = validateField(fieldKey, value);
    setValidationErrors(prev => ({
      ...prev,
      [fieldKey]: error
    }));
  };

  const handleSave = async () => {
    if (validateAllFields()) {
      try {
        setSaving(true);
        
        // Parse existing kvpJson or create default structure
        const existingKvpJson = digitizedData?.kvpJson ? JSON.parse(digitizedData.kvpJson) : {};
        
        // Update kvpJson with current form values
        const updatedKvpJson = {
          ...existingKvpJson,
          finished_product_name: {
            value: getValueForField('finished_product_name'),
            confidence: existingKvpJson.finished_product_name?.confidence || 90
          },
          customer_finished_product_item_code: {
            value: getValueForField('customer_finished_product_item_code'),
            confidence: existingKvpJson.customer_finished_product_item_code?.confidence || 90
          },
          datalogger_item_code: {
            value: getValueForField('datalogger_item_code'),
            confidence: existingKvpJson.datalogger_item_code?.confidence || 90
          },
          "transport_condition_(Ambient Temperature)+15/+25": {
            value: getValueForField('transport_condition_(Ambient Temperature)+15/+25'),
            confidence: existingKvpJson['transport_condition_(Ambient Temperature)+15/+25']?.confidence || 90
          },
          "transport_condition_(Cold Store)+2/+8": {
            value: getValueForField('transport_condition_(Cold Store)+2/+8'),
            confidence: existingKvpJson['transport_condition_(Cold Store)+2/+8']?.confidence || 90
          },
          truck_temperature_prior_to_sealing: {
            value: getValueForField('truck_temperature_prior_to_sealing'),
            confidence: existingKvpJson.truck_temperature_prior_to_sealing?.confidence || 90
          },
          date_truck_closed_sealed: {
            value: getValueForField('date_truck_closed_sealed'),
            confidence: existingKvpJson.date_truck_closed_sealed?.confidence || 90
          },
          document_type: existingKvpJson.document_type || "FinishedProductDispatchCheckList",
          folder_name: existingKvpJson.folder_name || "PCI",
          site_name: existingKvpJson.site_name || "Dublin",
          filename: existingKvpJson.filename || digitizedData?.processedFileName,
          s3_location: existingKvpJson.s3_location
        };

        // Prepare API request payload
        const requestPayload = {
          vendorMosymphonyID: digitizedData?.vendorMosymphonyID || 3,
          digitizedExtractedDataList: [{
            poNumber: digitizedData?.poNumber,
            batchNumber: digitizedData?.batchNumber,
            processedFileName: digitizedData?.processedFileName,
            senderEmailID: digitizedData?.senderEmailID,
            emailReceivedTimestamp: digitizedData?.emailReceivedTimestamp,
            attachmentName: digitizedData?.attachmentName,
            documentType: digitizedData?.documentType,
            documentFormat: digitizedData?.documentFormat,
            emailSubject: digitizedData?.emailSubject || "",
            emailBody: digitizedData?.emailBody || "",
            schrockenCustomFileID: digitizedData?.schrockenCustomFileID,
            kvpJson: JSON.stringify(updatedKvpJson),
            siteName: digitizedData?.siteName
          }]
        };

        // Make API call
        const response = await axios.post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateDigitizedExtractedData`,
          requestPayload
        );

        if (response.data.status) {
          // Save changes locally
          setEditedValues(formValues);
          setIsEditable(false);
          setShowingOriginal(false);
          
          console.log('Finished Product Check List data saved successfully');
        } else {
          console.error('Failed to save:', response.data.message);
        }
      } catch (error) {
        console.error('Error saving Finished Product Check List data:', error);
      } finally {
        setSaving(false);
      }
    }
  };

  const getFieldErrorProps = (fieldKey) => ({
    error: !!validationErrors[fieldKey],
    helperText: validationErrors[fieldKey]
  });

  const renderField = (fieldKey, label, placeholder, multiline = false, rows = 1, isSelect = false, options = []) => (
    <Grid
      container
      alignItems="center"
      spacing={2}
      className={classes.formField}
    >
      <Grid item xs={4}>
        <Box display="flex" alignItems="center">
          <Typography
            style={{
              paddingRight: 16,
              fontWeight: 500,
            }}
          >
            {label}
            <span className={classes.requiredStar}>*</span>
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={8}>
        {isSelect ? (
          <TextField
            select
            variant="outlined"
            fullWidth
            size="small"
            value={getValueForField(fieldKey)}
            onChange={(e) => handleInputChange(fieldKey, e.target.value)}
            onBlur={(e) => {
              const { value } = e.target;
              // Trim leading and trailing spaces for string values
              if (typeof value === "string" && value.trim() !== value) {
                handleInputChange(fieldKey, value.trim());
              }
            }}
            {...getFieldErrorProps(fieldKey)}
            InputProps={{
              readOnly: !isEditable,
              endAdornment: (
                <InputAdornment position="end">
                  <Box display="flex" alignItems="center" pl={1}>
                    <Box
                      style={{
                        width: 1,
                        height: 39,
                        backgroundColor: "#ccc",
                        marginRight: 3,
                      }}
                    />
                    {!isEditable ? (
                      getValueForField(fieldKey) !== getValueForField(fieldKey, originalValues) ? (
                        <Box
                          onClick={() => {
                            setModalData({
                              field: label,
                              before: getValueForField(fieldKey, originalValues),
                              after: getValueForField(fieldKey),
                              updatedBy: "user123",
                              timestamp: new Date().toLocaleString(),
                            });
                            setOpenModal(true);
                          }}
                          style={{
                            backgroundColor: "#7777",
                            color: "white",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            minWidth: 24,
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                        >
                          <Info fontSize="small" />
                        </Box>
                      ) : (
                        <Box
                          style={{
                            backgroundColor: getLevelColor(getConfidenceForField(fieldKey)),
                            color: "white",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            minWidth: 24,
                            textAlign: "center",
                          }}
                        >
                          {Math.round(getConfidenceForField(fieldKey))}
                        </Box>
                      )
                    ) : (
                      <Box
                        style={{
                          backgroundColor: getLevelColor(getConfidenceForField(fieldKey)),
                          color: "white",
                          borderRadius: 4,
                          padding: "2px 8px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          minWidth: 24,
                          textAlign: "center",
                        }}
                      >
                        {Math.round(getConfidenceForField(fieldKey))}
                      </Box>
                    )}
                  </Box>
                </InputAdornment>
              ),
            }}
          >
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        ) : (
          <TextField
            variant="outlined"
            fullWidth
            size="small"
            value={getValueForField(fieldKey)}
            onChange={(e) =>
              handleInputChange(fieldKey, e.target.value)
            }
            onBlur={(e) => {
              const { value } = e.target;
              // Trim leading and trailing spaces for string values
              if (typeof value === "string" && value.trim() !== value) {
                handleInputChange(fieldKey, value.trim());
              }
            }}
            placeholder={placeholder}
            multiline={multiline}
            rows={rows}
            {...getFieldErrorProps(fieldKey)}
            InputProps={{
              readOnly: !isEditable,
              endAdornment: (
                <InputAdornment position="end">
                  <Box display="flex" alignItems="center" pl={1}>
                    <Box
                      style={{
                        width: 1,
                        height: multiline ? 50 : 39,
                        backgroundColor: "#ccc",
                        marginRight: 3,
                      }}
                    />
                    {!isEditable ? (
                      getValueForField(fieldKey) !== getValueForField(fieldKey, originalValues) ? (
                        <Box
                          onClick={() => {
                            setModalData({
                              field: label,
                              before: getValueForField(fieldKey, originalValues),
                              after: getValueForField(fieldKey),
                              updatedBy: "user123",
                              timestamp:
                                new Date().toLocaleString(),
                            });
                            setOpenModal(true);
                          }}
                          style={{
                            backgroundColor: "#7777",
                            color: "white",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            minWidth: 24,
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                        >
                          <Info fontSize="small" />
                        </Box>
                      ) : (
                        <Box
                          style={{
                            backgroundColor: getLevelColor(getConfidenceForField(fieldKey)),
                            color: "white",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            minWidth: 24,
                            textAlign: "center",
                          }}
                        >
                          {Math.round(getConfidenceForField(fieldKey))}
                        </Box>
                      )
                    ) : (
                      <Box
                        style={{
                          backgroundColor: getLevelColor(getConfidenceForField(fieldKey)),
                          color: "white",
                          borderRadius: 4,
                          padding: "2px 8px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          minWidth: 24,
                          textAlign: "center",
                        }}
                      >
                        {Math.round(getConfidenceForField(fieldKey))}
                      </Box>
                    )}
                  </Box>
                </InputAdornment>
              ),
            }}
          />
        )}
      </Grid>
    </Grid>
  );

  return (
    <>
      <Grid container direction="column" spacing={2}>

        {/* Actions*/}
        <Grid item container alignItems="center" spacing={2}>
          <Grid item xs={6}>
            <Grid item style={{display: "flex", alignItems: "center"}} spacing={2}>
              <Typography
                variant="h6"
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  marginRight: "8px",
                }}
              >
                Finished Product Dispatch Check List Data
              </Typography>
              <Box display="flex" gap={1} spacing={2}>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={() => {
                    if (isEditable) {
                      handleSave();
                    } else {
                      // Start editing
                      setIsEditable(true);
                      setShowingOriginal(false);
                      setFormValues(editedValues);
                    }
                  }}
                  style={{ marginRight: "8px", minWidth: 15, textAlign: "center" }}
                  disabled={saving}
                >
                  {saving ? "Saving..." : isEditable ? "Save Changes" : "Edit"}
                </Button>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={() => {
                    if (showingOriginal) {
                      // Show edited version
                      setFormValues(editedValues);
                      setShowingOriginal(false);
                    } else {
                      // Show original version
                      setFormValues(originalValues);
                      setShowingOriginal(true);
                    }
                    setIsEditable(false);
                  }}
                  style={{ marginRight: "8px", minWidth: 20, textAlign: "center", size: "20px" }}
                >
                  {showingOriginal ? "Show Edited Version" : "Show Unedited Version"}
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h6">PDF Preview</Typography>
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              {/* Sponsor Description */}
              {renderField('finished_product_name', 'Sponsor Description', 'Enter Sponsor Description')}

              {/* Sponsor SKU */}
              {renderField('customer_finished_product_item_code', 'Sponsor SKU', 'Enter Sponsor SKU')}

              {/* TempTale Serial Number */}
              {renderField('datalogger_item_code', 'TempTale Serial Number', 'Enter TempTale Serial Number')}

              {/* Truck Temperature Prior to Sealing */}
              {renderField('truck_temperature_prior_to_sealing', 'Truck Temperature Prior to Sealing', 'Enter Truck Temperature Prior to Sealing')}

              {/* Temperature Range and Set Point */}
              <Grid item xs={12} style={{ marginTop: 16, marginBottom: 8 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                  Temperature Range and Set Point
                </Typography>
              </Grid>

              {/* Transport Condition (Ambient Temperature) +15/+25 */}
              {renderField('transport_condition_(Ambient Temperature)+15/+25', 'Transport Condition (Ambient Temperature) +15/+25', '', false, 1, true, ['Yes', 'No', 'N/A'])}

              {/* Transport Condition (Cold Store) -2/+8 */}
              {renderField('transport_condition_(Cold Store)+2/+8', 'Transport Condition (Cold Store) -2/+8', '', false, 1, true, ['Yes', 'No', 'N/A'])}

              {/* CMO Readiness Date */}
              {renderField('date_truck_closed_sealed', 'CMO Readiness Date', 'Enter CMO Readiness Date (DD MMM YYYY)')}

              <Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:{" "}
                </Typography>
                <Grid item style={{ width: "28px" }} />
                {/* Green Box */}
                <Box
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                  }}
                >
                  &gt; 90
                </Box>
                {/* Orange Box */}
                <Box
                  style={{
                    backgroundColor: "orange",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 50,
                    marginLeft: 16,
                  }}
                >
                  80 to 90
                </Box>
                {/* Red Box */}
                <Box
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                    marginLeft: 16,
                  }}
                >
                  &lt; 80
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Right side: PDF view */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              <Box
                style={{
                  height: 500,
                  backgroundColor: "#f5f5f5",
                  border: "1px dashed #ccc",
                }}
              >
                {schrockenCustomFileID ? (
                  <PDFViewer schrockenCustomFileID={schrockenCustomFileID} />
                ) : (
                  <Box
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography>No PDF available</Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>

          <Table>
            <TableHead
              style={{ border: "1px solid grey", backgroundColor: "#7777" }}
            >
              <TableRow
                style={{ border: "1px solid grey", backgroundColor: "#7777" }}
              >
                <TableCell>
                  <b>Timestamp</b>
                </TableCell>
                <TableCell>
                  <b>Before Value</b>
                </TableCell>
                <TableCell>
                  <b>After Value</b>
                </TableCell>
                <TableCell>
                  <b>Updated By</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ border: "1px solid grey" }}>
              <TableRow>
                <TableCell>{modalData.timestamp}</TableCell>
                <TableCell>{modalData.before}</TableCell>
                <TableCell>{modalData.after}</TableCell>
                <TableCell>{modalData.updatedBy}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default FinishedProductCheckList;
